import { connect } from 'react-redux'
import * as Actions from 'store/actions'
import { getScreenSize } from 'store/selectors'

const mapStateToProps = state => ({ screenSize: getScreenSize(state) })

const mapDispatchToProps = (dispatch) => ({
  onWindowResize: (screenSize) => dispatch(Actions.application.onWindowResize(screenSize))
})

export default connect(mapStateToProps, mapDispatchToProps)
